export default __webpack_public_path__ + "cec5dbbde623a23c0e7239e969a366d1.svg";